import { NavLink } from 'react-router';
import EcologyBookIcon from '@/assets/ecology-book.svg?react';
import GoogleDocsIcon from '@/assets/google-docs.svg?react';
import PlaystationGamepadIcon from '@/assets/playstation-gamepad.svg?react';
// import StarIcon from '@/assets/star.svg?react';
import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/material/styles';
import Section from './Section';
import useHasUserPermissions from '@/hooks/useHasUserPermissions';

const ResourcesNavigation = () => {
  const canViewGames = useHasUserPermissions([
    'markets.read',
    'games.read',
  ]);
  const canViewCompliance = useHasUserPermissions([
    'markets.read',
    'compliance_documents.read',
  ]);
  const canViewMarketing = useHasUserPermissions([
    'markets.read',
    'marketing_assets.read',
  ]);

  return (
    <Section
      title={
        <FormattedMessage id="resources" defaultMessage="Resources" />
      }
      aria-label="Resources navigation"
      mode="dark"
      defaultOpen
    >
      <Links>
        {canViewGames && (
          <StyledLink to="/games" aria-label="Games">
            <PlaystationGamepadIcon />
            <FormattedMessage id="games" defaultMessage="Games" />
          </StyledLink>
        )}
        {canViewCompliance && (
          <StyledLink
            to="/compliance"
            aria-label="Compliance Documents"
          >
            <GoogleDocsIcon />
            <FormattedMessage
              id="complianceDocuments"
              defaultMessage="Compliance Documents"
            />
          </StyledLink>
        )}
        {canViewMarketing && (
          <StyledLink to="/marketing" aria-label="Marketing Assets">
            <EcologyBookIcon />
            <FormattedMessage
              id="marketingAssets"
              defaultMessage="Marketing Assets"
            />
          </StyledLink>
        )}
      </Links>
    </Section>
  );
};

const Links = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

const StyledLink = styled(NavLink)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  gap: theme.spacing(1),
  color: theme.palette.white,
  fontSize: 14,
  lineHeight: '20px',
  fontWeight: 500,
  borderRadius: 20,
  padding: 12,
  transition: 'background 0.2s ease-in-out',

  path: {
    stroke: theme.palette.white,
  },

  '&.active': {
    background: theme.palette.primary.main,
  },
}));

export default ResourcesNavigation;
